import React from 'react'
import css from './ImageLoader.module.scss'
import {fromModule} from 'util/styler/Styler'

const styles = fromModule(css)

export const ImageLoader: React.FC<{}> = () => (
	<div className={styles.imageloader()} />
)
